import { makeStyles } from "@saleor/macaw-ui";
import React from "react";

interface HeadColoredProps {
  height?: number;
  fixedTop?: boolean;
}

const HeadColored: React.FC<HeadColoredProps> = props => {
  const { fixedTop, ...rest } = props;
  const defaultHeight: number = 18;
  const height: number = props.height ? props.height : defaultHeight;

  const useStyles = makeStyles(
    () => ({
      root: {
        height: `${height}px`,
        display: "flex",
        position: props.fixedTop ? "fixed" : "relative",
        top: props.fixedTop ? 0 : "",
        left: props.fixedTop ? 0 : "",
        width: "100%",
        zIndex: 1000
      },
      gradient: {
        position: "absolute",
        width: "100%",
        height: "100%",
        backgroundBlendMode: "multiply",
        mixBlendMode: "multiply"
      },
      layer1: {
        background:
          "linear-gradient(90deg, #601863 0%, #6B1A64 6%, #892168 18%, #BA2D6F 33%, #FC3D79 50%, rgba(255, 223, 159, 0) 100%)",
        right: "37.5%",
        zIndex: 1
      },
      layer2: {
        background:
          "linear-gradient(90deg, rgba(255, 223, 159, 0) -0.08%, #00B9A3 50.07%, #009FB8 100.22%)",
        left: "22.22%",
        zIndex: 2
      }
    }),
    { name: "HeadColored" }
  );

  const classes = useStyles(props);

  return (
    <div {...rest}>
      <div className={classes.root}>
        <div className={`${classes.gradient} ${classes.layer1}`} />
        <div className={`${classes.gradient} ${classes.layer2}`} />
      </div>
    </div>
  );
};

export default HeadColored;
